export const animation = {
    slideLeft: `transition-timing-function: ease; transition: 0.2s; animation: 0.5s slide-left; @keyframes slide-left { from { margin-left: 100%; } to { margin-left: 0%; }}`,
    slideRight: `transition-timing-function: ease; transition: 0.2s; animation: 0.5s slide-right; @keyframes slide-right { from { margin-left: -100%; } to { margin-left: 0%; }}`,
};
